import { useContext, useEffect, useState } from 'react';
import { SnackBar } from '../../Product/PdpHeader/styled';
import BogoProductListingPopup from '../../StoreCategoryPage/BogoProductListingPopup';
import AddToCartButton from '../AddToCartButton';
import AddButton from '../BogoClothDiaper/AddButton';
import PlusMinusButtons from '../BogoClothDiaper/PlusMinusButtons';
import CardContext from './ProductCardContext';

export default function CardButtons(props) {
  const { isForNewCdPage } = props;
  const contextData = useContext(CardContext);
  const [errorMessage, setErrorMessage] = useState('');
  useEffect(() => {
    if (errorMessage.length > 0) {
      setTimeout(() => {
        setErrorMessage('');
      }, [3000]);
    }
  }, [errorMessage]);

  return (
    <>
      {!contextData.hideStickyStrip && contextData.offerCartData ? (
        contextData.productData?.addToCart ? (
          <AddButton isForNewCdPage={isForNewCdPage} />
        ) : (
          <PlusMinusButtons setErrorMessage={setErrorMessage} />
        )
      ) : (
        <AddToCartButton />
      )}
      <SnackBar className={errorMessage.length > 0 ? 'show' : ''}>
        {errorMessage}
      </SnackBar>
      {contextData.showImagesPopup ? <BogoProductListingPopup /> : null}
    </>
  );
}
